module.exports = __webpack_public_path__ + "static/media/logo.05916d79.svg";